import React from 'react';
import logo from '../assets/peticle-icon.png';
import {APP_STORE_URL, PLAY_STORE_URL, navLinks} from './content';

const linkClass = 'text-white/70 text-sm hover:text-white transition-colors';

function Footer() {
    return (
        <footer className="bg-[#1C3324] pt-16 pb-8 px-4 sm:px-6">
            <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-10 mb-12">
                <div className="col-span-2 md:col-span-1">
                    <a href="/" className="flex items-center gap-2.5">
                        <img className="rounded-xl" src={logo} width={36} height={36} alt="Peticle logo"/>
                        <span className="text-xl font-extrabold tracking-tight text-white">Peticle</span>
                    </a>
                    <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
                        AI-powered pet health insights, records and reminders. Made with care by Unit 326.
                    </p>
                    <div className="mt-5 flex gap-2">
                        <a target="_blank" rel="noreferrer" href="https://x.com/peticle_app" aria-label="Peticle on X"
                           className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                            <i className="fa fa-twitter"></i>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/peticle.app" aria-label="Peticle on Instagram"
                           className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                            <i className="fa fa-instagram"></i>
                        </a>
                    </div>
                </div>

                <div>
                    <h6 className="text-xs uppercase tracking-[0.18em] font-bold text-white/40 mb-4">Product</h6>
                    <div className="flex flex-col gap-2.5">
                        {navLinks.map((l) => <a key={l.href} href={l.href} className={linkClass}>{l.label}</a>)}
                    </div>
                </div>

                <div>
                    <h6 className="text-xs uppercase tracking-[0.18em] font-bold text-white/40 mb-4">Download</h6>
                    <div className="flex flex-col gap-2.5">
                        <a target="_blank" rel="noreferrer" href={APP_STORE_URL} className={linkClass}>App Store</a>
                        <a target="_blank" rel="noreferrer" href={PLAY_STORE_URL} className={linkClass}>Google Play</a>
                    </div>
                </div>

                <div>
                    <h6 className="text-xs uppercase tracking-[0.18em] font-bold text-white/40 mb-4">Support</h6>
                    <div className="flex flex-col gap-2.5">
                        <a href="mailto:hello@unit326.com" className={linkClass}>hello@unit326.com</a>
                        <a href="/privacy-policy" className={linkClass}>Privacy Policy</a>
                        <a href="/data-settings" className={linkClass}>Data Settings</a>
                    </div>
                </div>
            </div>
            <div className="max-w-6xl mx-auto border-t border-white/10 pt-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-white/50">
                <span>© {new Date().getFullYear()} Peticle by Unit 326. All rights reserved.</span>
                <span>Not a substitute for professional veterinary care.</span>
            </div>
        </footer>
    );
}

export default Footer;
